<template>
  <footer class="site-footer">
    <div class="footer-content">
      <div class="footer-links">
        <a href="/privacy" class="footer-link">{{ $t('footer.privacy') }}</a>
        <span class="footer-sep">·</span>
        <a href="/terms" class="footer-link">{{ $t('footer.terms') }}</a>
        <span class="footer-sep">·</span>
        <a href="/contacts" class="footer-link">{{ $t('footer.contact') }}</a>
      </div>
      <div class="footer-copy">
        &copy; {{ year }} Lingvo News. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear();
</script>

<style scoped>
.site-footer {
  padding: 32px 20px 28px;
  text-align: center;
  color: #888;
  font-size: 13px;
  line-height: 1.6;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  color: #999;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #ccc;
}

.footer-sep {
  color: #555;
}

.footer-copy {
  color: #666;
  font-size: 12px;
}

@media (max-width: 480px) {
  .site-footer {
    padding: 24px 16px 20px;
    font-size: 12px;
  }

  .footer-copy {
    font-size: 11px;
  }
}
</style>
